<script setup>
import {computed, watch, onBeforeMount} from 'vue'
import {useStore} from 'vuex'
import {useRoute} from 'vue-router'

import {Settings, Users, CreditCard} from 'lucide-vue-next'
import {Button} from '@/components/ui/button'
import { useCheckOrgAccess } from '@/composables/useCheckAccess'
import { useFeatures } from '@/composables/useFeatures'

const store = useStore()
const route = useRoute()
const { showBillingPage } = useFeatures()
const orgId = computed(() => parseInt(route.params.org_id))
const org = computed(() => store.getters['org/getCurrent'])

onBeforeMount(() => {
  store.dispatch('org/fetchOrg', orgId.value)
})

watch(orgId, (newOrgId) => {
  store.dispatch('org/fetchOrg', newOrgId)
})
</script>

<template>
  <div v-if="org" :key="org.organization_id" class="flex items-center justify-between px-3 pt-3">
    <div class="flex items-center justify-end space-x-2">
      <router-link :to="{ name: 'OrgMembers', params: { org_id: orgId }} ">
        <Button size="sm" :variant="route.name === 'OrgMembers' ? 'default' : 'secondary' " class="h-8">
          <Users class="w-4 h-4 mr-2" />
          Members
        </Button>
      </router-link>

      <router-link :to="{ name: 'OrgSettings', params: { org_id: orgId }} " v-if="useCheckOrgAccess(org, 'org', ['update'])">
        <Button size="sm" :variant="route.name === 'OrgSettings' ? 'default' : 'secondary' " class="h-8">
          <Settings class="w-4 h-4 mr-2" />
          Settings
        </Button>
      </router-link>

      <router-link :to="{ name: 'OrgBilling', params: { org_id: orgId }} " v-if="showBillingPage && useCheckOrgAccess(org, 'org_billing', ['read'])">
        <Button size="sm" :variant="route.name === 'OrgBilling' ? 'default' : 'secondary' " class="h-8">
          <CreditCard class="w-4 h-4 mr-2" />
          Billing
        </Button>
      </router-link>
    </div>
  </div>
  <div v-if="org" :key="org.organization_id" class="p-3">
    <router-view></router-view>
  </div>
</template>
